<template>
  <div>
    <drawer :app="app" />

    <v-container class="mt-1">
      <v-card raised>
        <v-card-title v-if="a != null">
          <div>{{ a.FirstName }} {{ a.LastName }} - {{ $t("labels.AddressHistory") }}</div>
        </v-card-title>


        <div v-if="sameAddressEnableFlag">
            <v-switch
                      class="ml-10"
                      color="primary"
                      v-model="sameAddressFlag"
                      label="Same address as primary applicant"
                      :false-value="false"
                      :true-value="true"
            ></v-switch>
        </div>

        <div style="margin: 1px 5px 5px 15px;">

          <div v-if="!sameAddressFlag">
            <div class="px-3" v-if="a != null">
              <v-row
                ><v-col
                  ><p>{{ $t("labels.AddressDesc") }} {{this.AddHistoryYears}} years.</p></v-col
                ></v-row
              >

              <v-row>
                <v-col cols="12">
                  <v-card class="mb-5" raised v-for="(addr, idx) in a.Addresses" v-bind:key="addr.ApplicantAddress.ApplicantAddress.ApplicantAddressID">
                    <v-card-title style="padding-bottom: 0 !important;">
                      {{ $t("labels.Address") }} {{ idx + 1 }}

                      <v-switch
                        class="ml-10"
                        color="primary"
                        v-model="addr.ApplicantAddress.ApplicantAddress.ApplicantAddressTypeDD"
                        :label= "$t('labels.CurrentAddress')"
                        :false-value="1"
                        :true-value="0"
                      ></v-switch>

                      <v-spacer />
                      <a link @click="deleteAddress(addr)">
                        <v-icon color="red">fas fa-trash-alt</v-icon>
                      </a>
                    </v-card-title>
                    <v-container>
                      <v-row dense no-gutters>
                        <v-col>
                          <p_applicantaddr
                            v-model="addr.ApplicantAddress.ApplicantAddress"
                            :key="addr.ApplicantAddress.ApplicantAddress.ApplicantAddressID"
                          />
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card>
                </v-col>
              </v-row>
            </div>
          </div>

          <v-card-actions class="mb-5 mt-10">
            <v-btn @click="back" color="grey lighten-1">{{ $t("labels.Back") }}</v-btn>
            <v-spacer />
            <v-btn :disabled="sameAddressFlag" @click="add" color="primary"><v-icon x-small class="mr-2">fas fa-plus</v-icon>{{$t('labels.AddAddress')}}</v-btn>
            <v-btn @click="next" color="primary">{{ $t("labels.Next") }}</v-btn>
          </v-card-actions>
        </div>


      </v-card>
    </v-container>

    <div class="loading" v-if="loadFlag">Loading&#8230;</div>
  </div>
</template>

<script>
import drawer from "@/pages/app/agent/user/app/drawerInviteApplicant";
import dataSvc from "@/services/dataService";
import localStorageSvc from "@/services/localStorage";
import model from "@/shared/dataModels/app";
import p_applicantaddr from "@/shared/components/applicantAddr";

export default {
  components: {
    p_applicantaddr,
    drawer,
  },
  data() {
    return {
      guid: this.$route.params.guid,
      AddHistoryYears: 3,
      currentAddress: "Current Address",
      sameAddressEnableFlag: false,
      sameAddressFlag: false,
      updateIndex: 0,
      loadFlag: false,
      app: model.appModel(),
      a: null,
      applicantID: this.$route.params.applicantid,
      mortgageApplicationID: this.$route.params.appid,
      siteID: this.$route.params.siteid,
      userID: null,
      drawerFlag: false,
    };
  },
  methods: {
    deleteAddress(addr) {
      this.$confirm(
        this.$t("labels.Warning"),
        this.$t("labels.ConfirmDeleteAddress"),
        () => {
          let applicantAddressID = addr.ApplicantAddress.ApplicantAddress.ApplicantAddressID;
          if (applicantAddressID <= 0) {
            let v = [];
            for (let i = 0; i < this.a.Addresses.length; i++) {
              let addr = this.a.Addresses[i].ApplicantAddress.ApplicantAddress;

              if (addr.ApplicantAddressID == undefined) {
                v.push(this.a.Addresses[i]);
              } else {
                if (addr.ApplicantAddressID !== applicantAddressID) v.push(this.a.Addresses[i]);
              }
            }
            this.a.Addresses = v;
          } else {
            this.loadFlag = true;
            let postData = {
              SiteID: this.siteID,
              UserID: this.userID,
              MortgageApplicationID: this.mortgageApplicationID,
              ApplicantID: this.a.ApplicantID,
              ApplicantAddressID: applicantAddressID,
            };
            dataSvc
              .getHttp()
              .post("/api/MTGAppRemoveAddressInvite", postData)
              .then((res) => {
                this.loadFlag = false;

                let v = [];
                for (let i = 0; i < this.a.Addresses.length; i++) {
                  let addr = this.a.Addresses[i].ApplicantAddress.ApplicantAddress;

                  if (addr.ApplicantAddressID == undefined) {
                    v.push(this.a.Addresses[i]);
                  } else {
                    if (addr.ApplicantAddressID !== applicantAddressID) v.push(this.a.Addresses[i]);
                  }
                }
                this.a.Addresses = v;
              });
          }
        },
        () => {}
      );
    },
    add() {
      this.a.Addresses.push(this.getNewAddressModel());
    },
    back() {
      this.$router.push("/" + this.siteID + "/InviteCoApplicant/" + this.mortgageApplicationID + '/' + this.guid + "/applicant/" + this.applicantID + "/identification");
    },
    next() {
      if (!this.valid()) return;
      this.loadFlag = true;
      let postData = {
        ApplicantAddresses: this.a.Addresses,
        SiteID: this.siteID,
        UserID: this.userID,
        MortgageApplicationID: this.mortgageApplicationID,
        ApplicantID: this.a.ApplicantID,
        SameAddressFlag: this.sameAddressFlag
      };
      dataSvc
        .getHttp()
        .post("/api/MTGAppUpsertAddressInvite", postData)
        .then((res) => {
          this.loadFlag = false;
           if(this.app.showIncome == true){
             this.$router.push("/" + this.siteID + "/InviteCoApplicant/" + this.mortgageApplicationID + '/' + this.guid + "/applicant/" + this.applicantID + "/income");
          }else if(this.app.showProperty == true){
             this.$router.push("/" + this.siteID + "/InviteCoApplicant/" + this.mortgageApplicationID + '/' + this.guid + "/applicant/" + this.applicantID + "/property");
          }else if(this.app.showAssets == true){
             this.$router.push("/" + this.siteID + "/InviteCoApplicant/" + this.mortgageApplicationID + '/' + this.guid + "/applicant/" + this.applicantID + "/asset");
          }else{
             this.$router.push("/" + this.siteID + "/InviteCoApplicant/" + this.mortgageApplicationID + '/' + this.guid + "/applicant/summary");
          }   
        });
    },
    valid() {

      if(this.sameAddressFlag) return true;

      let currentAddressCount = 0;
      for (let i = 0; i < this.a.Addresses.length; i++) {
        let addr = this.a.Addresses[i].ApplicantAddress.ApplicantAddress;
        if (addr.ApplicantAddressTypeDD == 0) {
          currentAddressCount++;
        }
      }
      if (currentAddressCount !== 1) {
        this.$alert(this.$t("labels.Warning"), this.$t("errors.AtLeastOneCurrentAddress"));
        return false;
      }

      let totalMonth = 0;
      for (let i = 0; i < this.a.Addresses.length; i++) {
        let addr = this.a.Addresses[i].ApplicantAddress.ApplicantAddress;
        totalMonth += addr.MonthsAtAddress;
      }
      // if (totalMonth < 36)
      if (totalMonth < (this.AddHistoryYears * 12))
       {
        let addressHistoryErrorMessage;
        if(localStorageSvc.getLanID() == 1) {
          addressHistoryErrorMessage = this.$t('errors.YearAddressHistory') + this.AddHistoryYears + " years."
        } else {
          addressHistoryErrorMessage = this.$t('errors.YearAddressHistoryPart1') +
           this.AddHistoryYears +
           this.$t('errors.YearAddressHistoryPart2') +
           this.AddHistoryYears + ' ans.'
        }
        this.$alert(this.$t("labels.Warning"), addressHistoryErrorMessage);

        return false;
      }

      for (let i = 0; i < this.a.Addresses.length; i++) {
        let addr = this.a.Addresses[i].ApplicantAddress.ApplicantAddress;
        if (!addr.StreetName) {
          this.$alert(this.$t("labels.Warning"), this.$t("errors.MissingAddress"));
          return false;
        }

        if (!addr.ResidentialStatusDD) {
          this.$alert(this.$t("labels.Warning"), this.$t("errors.MissingResidentialStatus"));
          return false;
        }

        if (addr.ResidentialStatusDD == 2 && addr.Rent <= 0) {
          this.$alert(this.$t("labels.Warning"), this.$t("errors.MissingRent"));
          return false;
        }
      }

      return true;
    },
    getNewAddressModel() {
      let rv = model.applicantAddressModel();
      rv.ApplicantAddressID = 0 - this.a.Addresses.length;
      rv.ApplicantAddress.ApplicantAddress.ApplicantAddressID = rv.ApplicantAddressID;
      return rv;
    },
    loadPage() {
      this.loadFlag = true;
      let postData = {
        SiteID: this.siteID,
        ApplicantID: this.applicantID,
        MortgageApplicationID: this.mortgageApplicationID,
        guid: this.guid
      };
      dataSvc
        .getHttp()
        .post("/api/MTGAPPLoadInvite", postData)
        .then((res) => {
          this.loadFlag = false;
          if (res.data.ReturnStatus.ReturnCode == 200) {
            this.app = res.data;
             this.AddHistoryYears = res.data.AddHistoryYears;
            for (let i = 0; i < this.app.Applicants.length; i++) {
              if (this.app.Applicants[i].ApplicantID == res.data.CurrentApplicantID) {
                this.a = this.app.Applicants[i];
              }
            }

            this.sameAddressEnableFlag = this.a.SameAddressEnableFlag;
            this.sameAddressFlag = this.a.SameAddressFlag;

            if (this.a.Addresses.length == 0) {
              this.a.Addresses.push(this.getNewAddressModel());
            }
            this.updateIndex++;
          }else{
            this.loadFlag = false;
             this.$alert(this.$t('labels.Warning'), this.$t('errors.InviteCoApplicantSubmitted'));
              setTimeout(()=>{
              window.location = '/' + this.siteID ;
              }, 5000);
          }
          this.app.UserID = this.userID;
          this.app.SiteID = this.siteID;
        });
    },
  },
  created() {
    this.currentAddress = this.$t("labels.CurrentAddress");
    this.userID = localStorageSvc.getUser();   
    this.loadPage();    
  },
  mounted() {},
  beforeRouteUpdate(to, from, next) {
    this.applicantID = to.params.applicantid;
    this.loadPage();
    next();
  },
};
</script>
